import { BrowserRouter, Routes, Route, NavLink } from 'react-router-dom'
// Imported first so the ?sso_token= capture in sso.js runs before any other
// module can rewrite the URL out from under it.
import RequireAuth from './auth/RequireAuth.jsx'
import UserBadge from './auth/UserBadge.jsx'
import Dashboard from './pages/Dashboard.jsx'
import WorkspaceDetail from './pages/WorkspaceDetail.jsx'

function VestigeLogo() {
  return (
    <div className="flex items-center gap-3">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <rect x="2" y="2" width="9" height="9" rx="1" fill="#e8a020" opacity="0.9" />
        <rect x="13" y="2" width="9" height="9" rx="1" fill="#e8a020" opacity="0.4" />
        <rect x="2" y="13" width="9" height="9" rx="1" fill="#e8a020" opacity="0.4" />
        <rect x="13" y="13" width="9" height="9" rx="1" fill="#e8a020" opacity="0.15" />
      </svg>
      <span className="font-mono text-sm font-semibold tracking-widest uppercase text-text">
        Vestige
      </span>
    </div>
  )
}

function TopNav({ user }) {
  return (
    <header
      className="flex items-center justify-between px-6 h-14 border-b border-border bg-surface"
      style={{ position: 'sticky', top: 0, zIndex: 50 }}
    >
      <NavLink to="/" aria-label="Vestige home">
        <VestigeLogo />
      </NavLink>

      <nav className="flex items-center gap-1">
        <NavLink
          to="/"
          end
          className={({ isActive }) =>
            `px-3 py-1.5 rounded text-xs font-medium tracking-wide transition-colors ${
              isActive
                ? 'text-accent bg-accent-faint'
                : 'text-text-dim hover:text-text hover:bg-surface2'
            }`
          }
        >
          Workspaces
        </NavLink>
      </nav>

      <div className="flex items-center gap-3">
        <span className="hidden sm:inline text-2xs font-mono text-text-faint tracking-widest uppercase">
          v0.1.0
        </span>
        <div
          className="w-2 h-2 rounded-full bg-green animate-pulse-slow"
          title="Backend connected"
          aria-label="Backend connected"
        />
        <UserBadge user={user} />
      </div>
    </header>
  )
}

export default function App() {
  return (
    <RequireAuth>
      {(user) => (
        <BrowserRouter>
          <div className="flex flex-col min-h-screen bg-ground">
            <TopNav user={user} />
            <main className="flex-1">
              <Routes>
                <Route path="/" element={<Dashboard />} />
                <Route path="/workspace/:id" element={<WorkspaceDetail />} />
              </Routes>
            </main>
          </div>
        </BrowserRouter>
      )}
    </RequireAuth>
  )
}
